/* Ability quote basket. Stores the list in localStorage (never the Shopify
   cart, which the event shops use for checkout) and sends it to the team
   through the Shopify contact form. No app, no external requests. */
(function () {
'use strict';
if (window.AFHQuote) return;
var KEY = 'afhq_v1', PKEY = 'afhq_pending';
var cfg = window.AFHQ_CFG || {};
var S = { items: [] };
var root, panel, views = {}, lastFocus = null, step = 1, closeT;
var capOn = false, capReady = false, pendingP = null, sendT;

function load() {
  try { var d = JSON.parse(localStorage.getItem(KEY)); S = d && d.items ? d : { items: [] }; }
  catch (e) { S = S || { items: [] }; }
}
function save() {
  try { localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) {}
  badge();
}
function tot() {
  var n = 0; S.items.forEach(function (i) { n += i.q; });
  return { p: S.items.length, n: n };
}
function find(v) { for (var i = 0; i < S.items.length; i++) if (S.items[i].v == v) return S.items[i]; return null; }
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
function summary() { var t = tot(); return plural(t.p, 'product') + ', ' + plural(t.n, 'item'); }
function thumb(u) { if (!u) return ''; if (u.indexOf('width=') > -1) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=144'; }

function badge() {
  var n = tot().n;
  document.querySelectorAll('[data-afhq-count]').forEach(function (b) {
    b.textContent = n > 99 ? '99+' : n;
    b.hidden = !n;
  });
}

function add(it, q) {
  q = Math.max(1, parseInt(q, 10) || 1);
  var f = find(it.v);
  if (f) f.q += q;
  else S.items.push({ v: String(it.v), t: it.t || 'Product', s: it.s || '', i: it.i || '', u: it.u || '', q: q });
  save();
  if (root && !root.hidden) render();
}
function setQty(v, q) {
  var f = find(v); if (!f) return;
  f.q = Math.max(1, Math.min(9999, parseInt(q, 10) || 1));
  save(); render();
}
function remove(v) {
  S.items = S.items.filter(function (i) { return i.v != v; });
  save(); render();
}

/* ---------- drawer ---------- */
var ICON = {
  x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
  bin: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>',
  bag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
  tick: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
};

function build() {
  if (root) return;
  root = document.createElement('div');
  root.className = 'afhq';
  root.hidden = true;
  root.innerHTML =
    '<div class="afhq-scrim" data-afhq-close></div>' +
    '<aside class="afhq-panel" role="dialog" aria-modal="true" aria-labelledby="afhq-title" tabindex="-1">' +
      '<header class="afhq-head">' +
        '<div class="afhq-top"><div class="afhq-hgroup"><h2 class="afhq-title" id="afhq-title">Your Quote</h2><p class="afhq-sub" data-afhq-sub></p></div>' +
        '<button type="button" class="afhq-icon afhq-x" data-afhq-close aria-label="Close">' + ICON.x + '</button></div>' +
        '<ol class="afhq-steps" data-afhq-steps>' +
          '<li class="afhq-st" data-st="1"><span class="afhq-dot">1</span>Products</li>' +
          '<li class="afhq-bar" aria-hidden="true"></li>' +
          '<li class="afhq-st" data-st="2"><span class="afhq-dot">2</span>Your Details</li>' +
        '</ol>' +
      '</header>' +
      '<div class="afhq-view" data-view="1">' +
        '<div class="afhq-scroll"><ul class="afhq-list" data-afhq-list></ul>' +
        '<button type="button" class="afhq-link" data-afhq-close>+ Add more products</button></div>' +
        '<footer class="afhq-foot"><p class="afhq-note">No payment and no commitment. The team replies with pricing and availability.</p>' +
        '<button type="button" class="afhq-btn afhq-g" data-afhq-next>Next: Your Details <span aria-hidden="true">&rarr;</span></button></footer>' +
      '</div>' +
      '<form class="afhq-view" data-view="2" method="post" action="/contact#afhq" accept-charset="UTF-8" novalidate>' +
        '<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">' +
        /* Shopify's contact email lists every contact[...] field as "Key: value"
           in form order, so these hidden fields ARE the email layout. The
           visible inputs below have no name and are copied in on submit. */
        '<input type="hidden" name="contact[Name]"><input type="hidden" name="contact[email]">' +
        '<input type="hidden" name="contact[Phone]"><input type="hidden" name="contact[Company]">' +
        '<input type="hidden" name="contact[Products Requested]"><input type="hidden" name="contact[Sent From]">' +
        '<div class="afhq-scroll afhq-fields">' +
          '<div class="afhq-2col">' +
            '<label><span>First name <i>*</i></span><input data-k="first" autocomplete="given-name" required></label>' +
            '<label><span>Last name <i>*</i></span><input data-k="last" autocomplete="family-name" required></label>' +
          '</div>' +
          '<label><span>Email <i>*</i></span><input type="email" data-k="email" autocomplete="email" required></label>' +
          '<label><span>Phone <i>*</i></span><input type="tel" data-k="phone" autocomplete="tel" required></label>' +
          '<label><span>Company name</span><input data-k="company" autocomplete="organization" placeholder="Optional"></label>' +
          '<div class="afhq-sum"><div><strong data-afhq-sumt></strong><span data-afhq-sumn></span></div><button type="button" class="afhq-link" data-afhq-back>Edit</button></div>' +
          '<p class="afhq-err" data-afhq-err hidden></p>' +
        '</div>' +
        '<footer class="afhq-foot afhq-row"><button type="button" class="afhq-btn afhq-o" data-afhq-back><span aria-hidden="true">&larr;</span> Back</button>' +
        '<button type="submit" class="afhq-btn afhq-g afhq-grow" data-afhq-send>Send Quote Request</button></footer>' +
      '</form>' +
      '<div class="afhq-view afhq-sent" data-view="3">' +
        '<div class="afhq-scroll afhq-center"><span class="afhq-tick">' + ICON.tick + '</span>' +
        '<h3 class="afhq-title">Quote Request Sent</h3><p class="afhq-sub" data-afhq-sentmsg></p></div>' +
        '<footer class="afhq-foot"><button type="button" class="afhq-btn afhq-g" data-afhq-close>Continue Browsing</button></footer>' +
      '</div>' +
      '<div class="afhq-view afhq-empty" data-view="0">' +
        '<div class="afhq-scroll afhq-center"><span class="afhq-tick afhq-muted">' + ICON.bag + '</span>' +
        '<h3 class="afhq-title">Your quote is empty</h3><p class="afhq-sub">Add products from any product page or collection, then send the list to the team in one go.</p></div>' +
        '<footer class="afhq-foot"><a class="afhq-btn afhq-g" href="' + esc(cfg.browse || '/collections/all') + '">Browse Products</a></footer>' +
      '</div>' +
    '</aside>';
  document.body.appendChild(root);
  panel = root.querySelector('.afhq-panel');
  root.querySelectorAll('[data-view]').forEach(function (v) { views[v.getAttribute('data-view')] = v; });

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button,a,[data-afhq-close]');
    if (!t) return;
    if (t.hasAttribute('data-afhq-close')) { e.preventDefault(); close(); return; }
    if (t.hasAttribute('data-afhq-next')) { go(2); return; }
    if (t.hasAttribute('data-afhq-back')) { go(1); return; }
    var row = t.closest('[data-v]'); if (!row) return;
    var v = row.getAttribute('data-v'), f = find(v); if (!f) return;
    if (t.hasAttribute('data-inc')) setQty(v, f.q + 1);
    else if (t.hasAttribute('data-dec')) setQty(v, f.q - 1);
    else if (t.hasAttribute('data-rm')) remove(v);
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-qty]')) setQty(e.target.closest('[data-v]').getAttribute('data-v'), e.target.value);
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Enter' && e.target.matches('[data-qty]')) { e.preventDefault(); e.target.blur(); }
    if (e.key === 'Tab') trap(e);
  });
  views['2'].addEventListener('submit', send);
  captcha(views['2']);
  views['2'].addEventListener('input', function (e) { e.target.classList.remove('is-bad'); if (!views['2'].querySelector('.is-bad')) views['2'].querySelector('[data-afhq-err]').hidden = true; });
}

function trap(e) {
  var f = Array.prototype.filter.call(panel.querySelectorAll('button,a[href],input:not([type=hidden])'), function (el) { return el.offsetParent !== null && !el.disabled; });
  if (!f.length) return;
  var a = f[0], z = f[f.length - 1];
  if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
  else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
}

function render() {
  if (!root) return;
  var t = tot(), view = step;
  if (step < 3 && !t.p) view = 0;
  Object.keys(views).forEach(function (k) { views[k].hidden = k != view; });
  var steps = root.querySelector('[data-afhq-steps]');
  steps.hidden = view === 0 || view === 3;
  steps.setAttribute('data-at', view);
  var title = root.querySelector('#afhq-title'), sub = root.querySelector('[data-afhq-sub]');
  root.querySelector('.afhq-hgroup').hidden = view === 3 || view === 0;
  root.classList.toggle('is-bare', view === 3 || view === 0);
  if (view === 1) { title.textContent = 'Your Quote'; sub.textContent = summary(); }
  if (view === 2) { title.textContent = 'Your Details'; sub.textContent = 'Where should we send your quote?'; }
  if (view === 1) {
    root.querySelector('[data-afhq-list]').innerHTML = S.items.map(function (i) {
      return '<li class="afhq-item" data-v="' + esc(i.v) + '">' +
        '<a class="afhq-thumb" href="' + esc(i.u || '#') + '" tabindex="-1">' + (i.i ? '<img src="' + esc(thumb(i.i)) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div class="afhq-meta"><a class="afhq-name" href="' + esc(i.u || '#') + '">' + esc(i.t) + '</a>' + (i.s ? '<span class="afhq-sku">' + esc(i.s) + '</span>' : '') + '</div>' +
        '<div class="afhq-qty"><button type="button" data-dec aria-label="Decrease quantity"' + (i.q <= 1 ? ' disabled' : '') + '>&minus;</button>' +
        '<input data-qty type="number" inputmode="numeric" min="1" max="9999" value="' + i.q + '" aria-label="Quantity for ' + esc(i.t) + '">' +
        '<button type="button" data-inc aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="afhq-icon afhq-rm" data-rm aria-label="Remove ' + esc(i.t) + '">' + ICON.bin + '</button></li>';
    }).join('');
  }
  if (view === 2) {
    root.querySelector('[data-afhq-sumt]').textContent = summary();
    root.querySelector('[data-afhq-sumn]').textContent = S.items.map(function (i) { return i.t; }).join(', ');
  }
}

function go(n) {
  step = n; render();
  var v = views[step === 1 && !tot().p ? '0' : String(step)];
  var s = v && v.querySelector('.afhq-scroll'); if (s) s.scrollTop = 0;
  if (n === 2) { var f = views['2'].querySelector('input:not([type=hidden])'); if (f && window.matchMedia('(min-width: 768px)').matches) f.focus(); }
}

function open(at) {
  build();
  clearTimeout(closeT);
  var tt = document.querySelector('.afhq-toast'); if (tt) tt.classList.remove('is-on');
  if (at) step = at; else if (step === 3) step = 1;
  render();
  if (root.hidden) {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('afhq-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); panel.focus({ preventScroll: true }); }); });
  }
}
function close() {
  if (!root || root.hidden) return;
  root.classList.remove('is-open');
  document.documentElement.classList.remove('afhq-lock');
  closeT = setTimeout(function () { root.hidden = true; if (step === 3) step = 1; }, 320);
  if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
}

/* ---------- send ---------- */
function body() {
  var o = location.origin, t = tot(), lines = [plural(t.n, 'item') + ' across ' + plural(t.p, 'product'), ''];
  S.items.forEach(function (i) {
    lines.push(i.q + ' x ' + i.t + (i.s ? ' (' + i.s + ')' : ''));
    if (i.u) lines.push(i.u.indexOf('http') === 0 ? i.u : o + i.u);
    lines.push('');
  });
  return lines.join('\n').replace(/\n+$/, '');
}
function sentMsg(p) {
  views['3'].querySelector('[data-afhq-sentmsg]').textContent =
    'Thanks, ' + p.n + '. The team has your list of ' + plural(p.p, 'product') + ' and will reply to ' + p.e + '.';
}
function done(p) {
  S = { items: [] }; save();
  try { sessionStorage.removeItem(PKEY); } catch (e) {}
  sentMsg(p); step = 3; open(3);
}
/* The store has Shopify's hCaptcha spam protection switched on for contact
   forms. A contact POST without a valid h-captcha-response is accepted and
   redirected to ?contact_posted=true, but Shopify drops it as spam and no
   email is sent. Shopify.captcha.protect() is Shopify's API for binding
   hCaptcha to a form rendered by JavaScript: it wraps form.submit() so the
   invisible challenge runs first, adds the token, then calls the submit
   function the form had when it was bound. We set that to post(), so the
   request still goes by fetch (no page reload) but always carries a token. */
function captcha(f) {
  f.submit = post;
  var c = window.Shopify && window.Shopify.captcha;
  if (!c || typeof c.protect !== 'function') return;
  try { c.protect(f, function () { capReady = true; }); capOn = true; } catch (x) { capOn = false; }
}
function whenCap(cb) {
  if (!capOn || capReady) return cb(capReady || !capOn);
  var n = 0, t = setInterval(function () {
    if (capReady || ++n > 80) { clearInterval(t); cb(capReady); }
  }, 100);
}
function busy(on) {
  var btn = views['2'].querySelector('[data-afhq-send]');
  btn.disabled = on; btn.textContent = on ? 'Sending...' : 'Send Quote Request';
  clearTimeout(sendT);
  if (on) sendT = setTimeout(function () {
    busy(false);
    var err = views['2'].querySelector('[data-afhq-err]');
    err.textContent = 'That took too long to send. Please try again.'; err.hidden = false;
  }, 30000);
}
function nativeSubmit() {
  /* Last resort: a normal form post. Shopify shows its own challenge page if
     needed, then redirects back with ?contact_posted=true and init() shows
     the Sent state. */
  try { sessionStorage.setItem(PKEY, JSON.stringify(pendingP)); } catch (x) {}
  HTMLFormElement.prototype.submit.call(views['2']);
}
function post() {
  var f = views['2'];
  fetch('/contact', { method: 'POST', body: new FormData(f), credentials: 'same-origin' })
    .then(function (r) {
      if (/contact_posted=true/.test(r.url)) { busy(false); return done(pendingP); }
      nativeSubmit();
    })
    .catch(nativeSubmit);
}
function send(e) {
  e.preventDefault();
  e.stopImmediatePropagation(); /* the captcha wrapper is only reached through f.submit() below */
  var f = views['2'], err = f.querySelector('[data-afhq-err]'), bad = null;
  if (f.querySelector('[data-afhq-send]').disabled) return;
  function fld(k) { return f.querySelector('[data-k="' + k + '"]'); }
  function val(k) { return fld(k).value.trim(); }
  ['first', 'last', 'email', 'phone'].forEach(function (k) {
    var el = fld(k), v = el.value.trim();
    var ok = v && (k !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) && (k !== 'phone' || v.replace(/\D/g, '').length >= 7);
    el.classList.toggle('is-bad', !ok);
    if (!ok && !bad) bad = el;
  });
  if (bad) { err.textContent = 'Please check the highlighted fields.'; err.hidden = false; bad.focus(); return; }
  err.hidden = true;
  var set = function (k, v) { f.elements['contact[' + k + ']'].value = v; };
  set('Name', val('first') + ' ' + val('last'));
  set('email', val('email'));
  set('Phone', val('phone'));
  set('Company', val('company') || '-');
  set('Products Requested', body());
  var from = location.origin + location.pathname;
  try { var u = new URL(location.href); u.searchParams.delete('preview_theme_id'); u.hash = ''; from = u.toString(); } catch (x) {}
  set('Sent From', from);
  pendingP = { n: val('first'), e: val('email'), p: tot().p };
  busy(true);
  whenCap(function (ok) {
    if (ok) f.submit(); /* captcha wrapper when bound, otherwise post() */
    else nativeSubmit();
  });
}

/* ---------- product card chips ---------- */
function toast(msg) {
  var t = document.querySelector('.afhq-toast');
  if (!t) {
    t = document.createElement('div'); t.className = 'afhq-toast'; t.setAttribute('role', 'status');
    document.body.appendChild(t);
    t.addEventListener('click', function (e) { if (e.target.closest('[data-afhq-open]')) { e.preventDefault(); t.classList.remove('is-on'); open(1); } });
  }
  t.innerHTML = '<span>' + esc(msg) + '</span><button type="button" data-afhq-open>View Quote</button>';
  t.classList.add('is-on');
  clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3500);
}
function chips() {
  if (cfg.event) return;
  document.querySelectorAll('[data-product-card]:not([data-afhq])').forEach(function (c) {
    c.setAttribute('data-afhq', '');
    var a = c.querySelector('a.product--title') || c.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    var host = c.querySelector('.product--card-image');
    if (!m || !host) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'afhq-chip';
    b.setAttribute('data-afhq-handle', m[1]);
    b.setAttribute('aria-label', 'Add ' + (a.textContent || '').trim() + ' to quote');
    b.innerHTML = '<span aria-hidden="true">+</span> Add To Quote';
    host.appendChild(b);
  });
}
function chipAdd(b) {
  if (b.classList.contains('is-busy')) return;
  b.classList.add('is-busy');
  fetch('/products/' + b.getAttribute('data-afhq-handle') + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) {
      var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      add({ v: v.id, t: p.title + (p.variants.length > 1 ? ', ' + v.title : ''), s: v.sku, i: (v.featured_image && v.featured_image.src) || p.featured_image, u: p.url || ('/products/' + p.handle) }, 1);
      b.classList.add('is-done'); b.innerHTML = '<span aria-hidden="true">&#10003;</span> Added';
      setTimeout(function () { b.classList.remove('is-done'); b.innerHTML = '<span aria-hidden="true">+</span> Add To Quote'; }, 1800);
      toast(p.title + ' added to your quote');
    })
    .catch(function () { location.href = '/products/' + b.getAttribute('data-afhq-handle'); })
    .then(function () { b.classList.remove('is-busy'); });
}

/* ---------- PDP button ---------- */
function pdpAdd(b) {
  var sec = b.closest('[data-pdp-section]') || document;
  var qi = b.getAttribute('data-qty-selector') && sec.querySelector(b.getAttribute('data-qty-selector'));
  var v = b.getAttribute('data-variant'), t = b.getAttribute('data-title') || document.title;
  var img = b.getAttribute('data-image');
  try {
    var vs = JSON.parse((sec.querySelector('[data-pdp-variants]') || {}).textContent || '[]');
    var hit = vs.filter(function (x) { return String(x.id) === String(v); })[0];
    if (hit && vs.length > 1 && hit.options) t += ', ' + hit.options.join(' / ');
  } catch (x) {}
  add({ v: v, t: t, s: b.getAttribute('data-variant-sku'), i: img, u: b.getAttribute('data-url') }, qi ? qi.value : 1);
  open(1);
}

/* ---------- wiring ---------- */
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-afhq-open],[data-afhq-add],.afhq-chip');
  if (!t || (root && root.contains(t))) return;
  e.preventDefault(); e.stopPropagation();
  if (t.classList.contains('afhq-chip')) chipAdd(t);
  else if (t.hasAttribute('data-afhq-add')) pdpAdd(t);
  else open(1);
}, true);

window.addEventListener('storage', function (e) { if (e.key === KEY) { load(); badge(); render(); } });

function init() {
  load(); badge(); chips();
  var main = document.getElementById('MainContent');
  if (main && window.MutationObserver) {
    var q = 0;
    new MutationObserver(function () { if (q) return; q = setTimeout(function () { q = 0; chips(); }, 200); })
      .observe(main, { childList: true, subtree: true });
  }
  var pend = null;
  try { pend = JSON.parse(sessionStorage.getItem(PKEY)); } catch (e) {}
  if (pend && /[?&]contact_posted=true/.test(location.search)) done(pend);
  else if (location.hash === '#quote' && !cfg.event) open(1);
}

load();
window.AFHQuote = { add: add, open: open, close: close, count: function () { return tot().n; }, badge: badge };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
